import React from 'react';
import Header from './../Header';
import { useState, useEffect, useCallback } from 'react'
import { Layout, Dialog } from 'element-react';
import userStore from '../../store/user';
import MyPreferencesWizard from './MyPreferencesWizard';
import {isDesktop} from 'react-device-detect';

import Joyride, {STATUS} from 'react-joyride';
import { useLocation } from 'react-router-dom';
import imageR1 from '../../assets/imgs/Recorrido1-sellers.png';
import imageR2 from '../../assets/imgs/Recorrido4-sellers.png'
import useShowWizardStore, { TOUR_KEYS } from '../../store/joyride-dashboard';

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
}

export default function AppLayout({ children, showLeftMenu, footerComponent, menuComponent, showMyPreferencesWizard, ...props}) {
    
    const { show, setShowTour } = useShowWizardStore();
    const [viewInSpanish, setViewInSpanish] = useState(false);
    const {user, setPendingSetupBusinessPreferences} = userStore();
    const [myPreferencesWizardEnabled, setMyPreferencesWizardEnabled] = useState(showMyPreferencesWizard)

    const [isTourRunning, setIsTourRunning] = useState(false);
    const [activeSteps, setActiveSteps] = useState([]);
    const [activeTourKey, setActiveTourKey] = useState(null);

    const location = useLocation();

    const { width } = useWindowSize();
    const isMobile = width < 992; 
    const isDesktopDevice = width >= 992;
    
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const onWizardComplete = () => { 
        console.log("on wizard complete function");
        setMyPreferencesWizardEnabled(false);
        setPendingSetupBusinessPreferences({...user }, false)
    }
    
    const currentPath = location.pathname;
    const pathsToHideSpacer = ['/seller-tools', '/buyer-tools', '/seller-tools-inf'];
    const hideSpacer = pathsToHideSpacer.includes(currentPath);

    useEffect(function() {
        setMyPreferencesWizardEnabled(showMyPreferencesWizard);
    }, [showMyPreferencesWizard]) 
    
    useEffect(() => {
        // Solo cerramos el menú si cambiamos de móvil a desktop o si no hay menú lateral
        if ((!isMobile || !showLeftMenu) && isMobileMenuOpen) {
            console.log("Cerrando menú móvil - cambio a desktop o sin menú lateral");
            setIsMobileMenuOpen(false);
        }
    }, [isMobile, showLeftMenu, isMobileMenuOpen]);

    // Use Effect para que el Menu en Movil se cierre
    useEffect(() => {
        // Se ejecuta cada vez que el pathname o el hash de la URL cambian.
        if (isMobileMenuOpen) {
            console.log("Cambio de URL detectado, cerrando menú móvil.");
            setIsMobileMenuOpen(false);
        }
    }, [location.pathname, location.hash]);

    useEffect(() => {
        console.log("useEffect - location/show changed:", location.pathname, show);

        const isSellerTourPage = location.pathname === "/dashboard";
        const isBuyerTourPage = location.pathname === "/tools/dashboard";

        const shouldStartSellerTour = isSellerTourPage && show[TOUR_KEYS.SELLER];
        const shouldStartBuyerTour = isBuyerTourPage && show[TOUR_KEYS.BUYER];

        // Lógica para iniciar o detener tours
        if (shouldStartSellerTour) {
            console.log("useEffect - Activating Seller Tour");
            setActiveSteps(stepsHub);
            setActiveTourKey(TOUR_KEYS.SELLER);
            setIsTourRunning(true);
        } else if (shouldStartBuyerTour) {
            console.log("useEffect - Activating Buyer Tour");
            setActiveSteps(stepBuyer);
            setActiveTourKey(TOUR_KEYS.BUYER);
            setIsTourRunning(true);
        } else {
            if (isTourRunning) {
                console.log("useEffect - No tour should run now or already stopped.");
                setIsTourRunning(false);
                setActiveSteps([]);
                setActiveTourKey(null);
            }
        }

    }, [location.pathname, show, isTourRunning]); 

    const toggleMobileMenu = useCallback((isOpen) => {
        if (isMobile && showLeftMenu) {
            setIsMobileMenuOpen(isOpen);
        }
    }, [isMobile, showLeftMenu]);

    const stepsHub = [
        {
            content: (
                <div className="custom-joyride-content">
                    <button 
                        className={`custom-joyride-button ${viewInSpanish ? 'spanish-active' : ''}`} 
                        onClick={() => setViewInSpanish(!viewInSpanish)}
                    >
                        <span>English</span>
                        <span>Español</span>
                    </button>
                    <img src={imageR1} alt="Bainub B2B" className="custom-joyride-image" />
                    <h2 className="custom-joyride-title">{viewInSpanish ? " Bienvenido a Bainub B2B" : "Welcome to Bainub B2B"}</h2>
                    <p className="custom-joyride-text">
                        ✅{' '}
                        {
                            viewInSpanish 
                            ?<>
                            Estás en el lugar correcto. Completa el perfil de tu empresa para destacar tus productos, recibir solicitudes de cotización y acceder a 
                            <span className='highlighted-text'> nuevas oportunidades de negocio.</span>
                            
                            </>
                            :<>
                            You're in the right place. Complete your company profile to show your products, receive quote requests, and access
                            <span className='highlighted-text'> new business opportunities.</span>
                            </>
                        }
                        
                    </p>
                    <div className="custom-joyride-progress">
                        <span className="custom-joyride-progress-text">1/4</span>
                        <div className="custom-joyride-progress-bar-container">
                            <div className="custom-joyride-progress-bar"></div>
                        </div>
                    </div>
        
                </div>
            ),
            placement: 'center',
            target: 'body',
            
        },
        {
            content:(<div className="custom-joyride-content2">
                    <button 
                        className={`custom-joyride-button ${viewInSpanish ? 'spanish-active' : ''}`} 
                        onClick={() => setViewInSpanish(!viewInSpanish)}
                    >
                        <span>English</span>
                        <span>Español</span>
                    </button>
                    <p className='custom-joyride-text'>
                        ✅{' '}
                        {viewInSpanish
                            ? <>
                                <span className='highlighted-text'>PASO 1</span> Esta es la sección de{' '}
                                <span className='highlighted-text'>'My Company'</span>: Aquí crea tu micrositio de empresa,
                                sube tu logotipo, una descripción en inglés y fotografías de tu empresa para destacar ante compradores
                                empresariales.
                            </>
                            : <>
                                <span className='highlighted-text'>STEP 1</span> This is section of{' '}
                                <span className='highlighted-text'>'My Company'</span>: Here you can upload your company information.
                                Add your logo, a description and company photos to engage business buyers.
                            </>}
                    </p>
                    <div className="custom-joyride-progress">
                        <span className="custom-joyride-progress-text">2/4</span>
                        <div className="custom-joyride-progress-bar-container">
                            <div className="custom-joyride-progress-bar2"></div>
                        </div>
                    </div>
                </div>
            ) ,
            placement: 'right',
            target: '.main-left-menu .el-menu-vertical-demo > div:nth-child(3) > .el-menu-item > label',
            isFixed: true,
        },
        {
            target: '.main-left-menu .el-menu-vertical-demo > div:nth-child(4) > .el-menu-item > label',
            content:(<div className="custom-joyride-content2">
                    <button 
                        className={`custom-joyride-button ${viewInSpanish ? 'spanish-active' : ''}`} 
                        onClick={() => setViewInSpanish(!viewInSpanish)}
                    >
                        <span>English</span>
                        <span>Español</span>
                    </button>
                    <p className='custom-joyride-text'>
                        &#x2705;{' '}
                        {viewInSpanish
                            ?<> 
                            <span className='highlighted-text'>Paso 2 </span>esta es la sección de
                            <span className='highlighted-text'> 'My Products'</span>: Aquí puedes subir fotos de tus productos, junto con información general y técnica en inglés, para que los compradores empresariales conozcan sus características y beneficios.
                            </>
                            :<> 
                            <span className='highlighted-text'>STEP 2 </span>This is
                            <span className='highlighted-text'> 'My Product' </span>section: Here you can upload photos of your products with general and technical information, so business buyers can learn about their features and benefits.
                            </>}
                    </p>
                    <div className="custom-joyride-progress">
                        <span className="custom-joyride-progress-text">3/4</span>
                        <div className="custom-joyride-progress-bar-container">
                            <div className="custom-joyride-progress-bar3"></div>
                        </div>
                    </div>
                </div>
             ) ,
             placement: 'right',
             isFixed: true,
        },
        {
            content: (
                <div className="custom-joyride-content4">
                    <button 
                        className={`custom-joyride-button ${viewInSpanish ? 'spanish-active' : ''}`} 
                        onClick={() => setViewInSpanish(!viewInSpanish)}
                    >
                        <span>English</span>
                        <span>Español</span>
                    </button>
                    <img src={imageR2} alt="Bainub B2B" className="custom-joyride-image4" />
                    <p className='custom-joyride-text'>
                        &#x2705;{' '}
                        {viewInSpanish
                            ?<>
                            <span className='highlighted-text'>¡Listo! En solo dos pasos puedes empezar en Bainub: </span>
                             Asegúrate de tener listo tu logotipo, la descripción de tu empresa, fotos y especificaciones de tus productos.
                            </>
                            :<>
                            <span className='highlighted-text'>In just two steps, you can get started on Bainub! </span>
                             Make sure you have your logo, company description, product photos, and specifications ready.
                            </>}
                    </p>
                    <p className="custom-joyride-parrafo">{viewInSpanish ? "Recuerda que toda la información debes subirla en idioma inglés" : "Remember to upload all information in English"}</p>
                    <div className="custom-joyride-progress">
                        <span className="custom-joyride-progress-text">4/4</span>
                        <div className="custom-joyride-progress-bar-container">
                            <div className="custom-joyride-progress-bar4"></div>
                        </div>
                    </div>
                </div>
            ),
            placement: 'center',
            target: 'span.h1-2',
        },
    ];

    const stepBuyer = [
        {
            content: (
                <div className="custom-joyride-content-Buyer">
                    <button 
                        className={`custom-joyride-button-buyer ${viewInSpanish ? 'spanish-active' : ''}`} 
                        onClick={() => setViewInSpanish(!viewInSpanish)}
                    >
                        <span>English</span>
                        <span>Español</span>
                    </button>
                    <img src={imageR1} alt="Bainub B2B" className="custom-joyride-image" />
                    <h2 className="custom-joyride-title">{viewInSpanish ? " Bienvenido a Bainub B2B" : "Welcome to Bainub B2B"}</h2>
                    <p className="custom-joyride-text">
                        ✅{' '}
                        {
                            viewInSpanish 
                            ?<>
                            Estás en el lugar correcto. Descubre productos y proveedores verificados de 
                            <span className='highlighted-text'> México, Estados Unidos y Canadá. </span>
                            Reduce costos con compras directas de fábrica y cotiza fácilmente con múltiples proveedores.
                            
                            <p className='highlighted-text'>Bainub: facilitamos las compras para ti y tu equipo.</p>
                            Múltiples fabricantes cercanos desde un solo y eficiente marketplace B2B.
                            </>
                            :<>
                            You're in the right place. Discover products and verified suppliers from 
                            <span className='highlighted-text'> Mexico, the USA, and Canada. </span>

                            Cut costs with factory-direct sourcing and request quotes from multiple suppliers—fast and hassle-free.

                            <p className='highlighted-text'> Bainub – We make sourcing easy for you and your team.</p>
                            Encuentra fabricantes de tu región en un único y eficiente Marketplace B2B.
                            </>
                        }
                        
                    </p>
                    <div className="custom-joyride-progress">
                        <span className="custom-joyride-progress-text">1/5</span>
                        <div className="custom-joyride-progress-bar-container">
                            <div className="custom-joyride-progress-bar-buyer"></div>
                        </div>
                    </div>
        
                </div>
            ),
            placement: 'center',
            target: 'body',
            styles: {
                options: {
                    width: 900,
                    height: 680,
                }
            }
        },
        {
            content:(<div className="custom-joyride-content2">
                    <button 
                        className={`custom-joyride-button ${viewInSpanish ? 'spanish-active' : ''}`} 
                        onClick={() => setViewInSpanish(!viewInSpanish)}
                    >
                        <span>English</span>
                        <span>Español</span>
                    </button>
                    <p className='custom-joyride-text'>
                        ✅{' '}
                        {viewInSpanish
                            ? <>
                                <span className='highlighted-text'>Usa nuestro buscador </span>para encontrar productos fácilmente y
                                 conectar al instante con fabricantes para discutir tus requerimientos técnicos y negociar términos.
                                
                            </>
                            : <>
                                <span className='highlighted-text'>Use our search engine </span>to easily find products and instantly connect with manufacturers 
                                to discuss technical requirements and negotiate terms.
                                
                            </>}
                    </p>
                    <div className="custom-joyride-progress">
                        <span className="custom-joyride-progress-text">2/5</span>
                        <div className="custom-joyride-progress-bar-container">
                            <div className="custom-joyride-progress-bar2-buyer"></div>
                        </div>
                    </div>
                </div>
            ) ,
            
            target: '.search-input-content-tour', 
            isFixed: true,
        },
        {
            content:(<div className="custom-joyride-content2-buyer">
                    <button 
                        className={`custom-joyride-button ${viewInSpanish ? 'spanish-active' : ''}`} 
                        onClick={() => setViewInSpanish(!viewInSpanish)}
                    >
                        <span>English</span>
                        <span>Español</span>
                    </button>
                    <p className='custom-joyride-text'>
                    
                        {viewInSpanish
                            ? <>
                                <span className='highlighted-text'>✅ ¿Interesado en un Proveedor en Bainub? </span>
                                    Inicia negociaciones en tiempo real desde el Bainub Message Center haciendo clic en el botón de Chat en su anuncio.
                                <p className='highlighted-text-gray'>Aquí puedes dar seguimiento fácilmente a tus conversaciones y acceder al historial de chat de cada uno de tus contactos.</p>
                                
                            </>
                            : <>
                                <p><span className='highlighted-text'>✅ Interested in a Bainub Supplier? </span>
                                    Start real-time negotiations in the Bainub Message Center by clicking the Chat button on their Ad.</p>
                                <p className='highlighted-text-gray'>Here, you can easily track your conversations and access the chat history of every Bainub Contact you've made.</p>
                                
                            </>}
                    </p>
                    <div className="custom-joyride-progress">
                        <span className="custom-joyride-progress-text">3/5</span>
                        <div className="custom-joyride-progress-bar-container">
                            <div className="custom-joyride-progress-bar3-buyer"></div>
                        </div>
                    </div>
                </div>
            ) ,
            target: '.sub-menu-tour', 
            isFixed: true,
        },
        { 
            content:(<div className="custom-joyride-content2">
                <button 
                    className={`custom-joyride-button ${viewInSpanish ? 'spanish-active' : ''}`} 
                    onClick={() => setViewInSpanish(!viewInSpanish)}
                >
                    <span>English</span>
                    <span>Español</span>
                </button>
                <p className='custom-joyride-text'>
                    ✅{' '}
                    {viewInSpanish
                        ? <>
                            <span className='highlighted-text'>¿Tienes un requerimiento de compra? </span>
                            Compártelo al instante con fabricantes verificados en Bainub usando RFQ DIRECT. Simplifica tu proceso de compras de forma fácil y eficiente.
                            
                        </>
                        : <>
                            <span className='highlighted-text'>Got a buying requirement? </span>
                            Instantly share it with verified manufacturers on Bainub using RFQ DIRECT. Simplify your procurement process with ease.
                            
                        </>}
                </p>
                <div className="custom-joyride-progress">
                    <span className="custom-joyride-progress-text">4/5</span>
                    <div className="custom-joyride-progress-bar-container">
                        <div className="custom-joyride-progress-bar4-buyer"></div>
                    </div>
                </div>
            </div>
        ) ,
            placement: 'right',
            target: '.main-left-menu .el-menu-vertical-demo > div:nth-child(4)', 
            isFixed: true,
        },
        {
            content: (
                <div className="#">
                    <button 
                        className={`custom-joyride-button5 ${viewInSpanish ? 'spanish-active' : ''}`} 
                        onClick={() => setViewInSpanish(!viewInSpanish)}
                    >
                        <span>English</span>
                        <span>Español</span>
                    </button>
                    <div className='box-image'>
                        <img src={imageR2} alt="Bainub B2B" className="custom-joyride-image4" />
                    </div>
                    <p className='custom-joyride-text'>
                        {viewInSpanish
                            ?<>
                            <p><span className='highlighted-text'>✅ En solo unos pasos, comienza a conectar con proveedores verificados cerca de ti.</span></p>
                            <p>¡Empieza a contactar fabricantes ahora y negocia tus necesidades!</p>
                            </>
                            :<>
                            <p><span className='highlighted-text'>✅ With just a few simple steps, you can start connecting with verified suppliers near you.</span></p>
                            <p className='highlighted-text-gray'>Start reaching out to manufacturers now and negotiate your requirements!</p>
                            </>}
                    </p>
                    <div className="custom-joyride-progress">
                        <span className="custom-joyride-progress-text">5/5</span>
                        <div className="custom-joyride-progress-bar-container">
                            <div className="custom-joyride-progress-bar4"></div>
                        </div>
                    </div>
                </div>
            ),
            placement: 'center',
            target: '.my-product-table', 
            hideBackButton: false, 
            locale: {
                last: viewInSpanish ? '¡Busca Productos Ahora!' : 'Search for products Now!'
            },
            tooltipFooter: {
                justifyContent: 'center',
            },
            styles: {
                options: {
                    width: 840,
                },
                buttonNext: {
                    width: '220px',
                    marginInlineStart: '0 !important',
                    marginRight: '15px',
                    marginLeft: '0',
                    marginBottom: '0px',
                },
                buttonBack: {
                    backgroundColor:'#dddddd',
                    color: '#777777',
                    marginLeft: '5px'
                }
            }
        },
    ];

    const locale = {
        back: 'Previous',
        last: 'Proceed'
    };

    const localeSpanish = {
        back: 'Anterior',
        last: 'Finalizar',
        next: 'Siguiente',
    };

    const styles = {
        options: {
            width: 700,
            height: 700,
            zIndex: 10000,
        },
        tooltipContainer: {
            textAlign: 'center',
        },
        tooltipFooter: {
            alignItems: 'center',
            display: 'flex',
            marginTop: '0px',
            justifyContent: 'space-between'
        },
        tooltipFooterSpacer: {
            display: 'none',
        },
        buttonNext: {
            width: '120px',
            height: '40px',
            backgroundColor: '#F76566',
            color: 'white',
            borderRadius: '30px',
            padding: '10px 20px',
            border: 'none',
            cursor: 'pointer',
            fontSize: '14px',
            marginInlineStart: 'auto',
            marginRight: '30px',
            outline: 'none',
            boxShadow: 'none',
        },
        buttonBack: {
            width: '120px',
            height: '40px',
            backgroundColor: '#F76566',
            color: 'white',
            borderRadius: '30px',
            padding: '10px 20px',
            border: 'none',
            cursor: 'pointer',
            fontSize: '14px',
            marginLeft: '30px',
        },
    };

    const handleJoyrideCallback = (data) => {
        const { status, type } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        console.log("handleJoyrideCallback - status:", status, "type:", type, "activeTourKey:", activeTourKey);

        if (finishedStatuses.includes(status)) {
            console.log(`handleJoyrideCallback - Tour '${activeTourKey}' ended, setting isTourRunning to false`);
            setIsTourRunning(false);

            if (activeTourKey) {
                console.log(`handleJoyrideCallback - Updating store: setShowTour('${activeTourKey}', false)`);
                setShowTour(activeTourKey, false); 
            }

            setActiveSteps([]);
            setActiveTourKey(null);
        } else {
           console.log("handleJoyrideCallback - Tour event:", type, status);
        }
    };

    console.log("Estado del menú móvil:", { isMobile, showLeftMenu, isMobileMenuOpen });

    return (
        <div>
            <Header loadCategories={props.loadCategories}/>
            <div className="app-container">
                
                {isMobile && showLeftMenu && (
                    <>
                        {/* BOTÓN PARA ABRIR - Solo se muestra si el menú está cerrado */}
                        {!isMobileMenuOpen && (
                            <button 
                                className="mobile-menu-open-btn" 
                                onClick={() => toggleMobileMenu(true)}
                            >
                                <span className="menu-text">
                                    {location.pathname === '/' ? 'Categories' : 'Menu'}
                                </span>
                                <span className="menu-icon">&gt;</span>
                            </button>
                        )}

                        <div 
                            className={`backdrop ${isMobileMenuOpen ? 'open' : ''}`}
                            onClick={() => toggleMobileMenu(false)}
                        />
                        
                        {/* CONTENEDOR DEL MENÚ MÓVIL */}
                        <div className={`sidebar-container-mobile ${isMobileMenuOpen ? 'open' : ''}`}>
                            {/* BOTÓN PARA CERRAR */}
                            <button 
                                className="mobile-menu-close-btn" 
                                onClick={() => toggleMobileMenu(false)}
                            >
                                &times;
                            </button>

                            {menuComponent && React.cloneElement(menuComponent, { isMobileLayout: true })}
                        </div>
                    </>
                )}

                <Layout.Row gutter={10} type="flex">
                    {showLeftMenu ? ( 
                        <>
                            {/* La columna del menú solo se renderiza si NO es móvil */}
                            {!isMobile && (
                                <Layout.Col className={props.searchType ? '' : 'leftBack'} sm={4} md={4} lg={4}>
                                    {menuComponent}
                                </Layout.Col>
                            )}
                        </>
                    ) : (
                        <>
                            {/* La columna espaciadora también se oculta en móvil */}
                            {!isMobile && (
                                <Layout.Col xs={1} sm={1} md={1} lg={1} 
                                  className={hideSpacer ? 'hide-spacer-column' : ''} >
                                    &nbsp;
                                </Layout.Col>
                            )}
                        </>
                    )}

                    {/* La columna del contenido principal - totalmente responsiva */}
                    <Layout.Col 
                        className="no-gutter" 
                        xs={24} // En móvil siempre ocupa todo el ancho
                        sm={showLeftMenu && !isMobile ? 20 : (hideSpacer ? 24 : 23)} 
                        md={showLeftMenu && !isMobile ? 20 : (hideSpacer ? 24 : 23)} 
                        lg={showLeftMenu && !isMobile ? 20 : (hideSpacer ? 24 : 23)}
                    >
                        <div>
                            {children}
                        </div>
                    </Layout.Col>
                </Layout.Row>
            </div>
            
            <div className="footer">
                {footerComponent}
            </div>

            {/* Renderiza Joyride solo si un tour está activo y tiene pasos */}
            {isTourRunning && activeSteps.length > 0 && isDesktopDevice && (
                <Joyride
                    steps={activeSteps}
                    run={isTourRunning}
                    styles={styles}
                    continuous={true}
                    showSkipButton={false}
                    scrollToFirstStep
                    callback={handleJoyrideCallback}
                    disableCloseOnEsc={true}
                    disableOverlayClose={true}
                    hideBackButton={false}
                    hideCloseButton={false}
                    locale={viewInSpanish ? localeSpanish : locale}
                />
            )}
        </div>
    )
}